import React from 'react';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';

const EducationSummaryPlaceholder = () => {
  return (
    <div data-component="EducationSummaryPlaceholder" data-testid="educational-summary-placeholder">
      <Skeleton grow disablePadding>
        <SkeletonLine variant="single" fullWidth />
        <SkeletonBlock aspect="wide" />
        <SkeletonLine variant="multi" numberOfLines={3} fullWidth />
      </Skeleton>
    </div>
  );
};

export { EducationSummaryPlaceholder };
